import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Cloud01 = function Cloud01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6.5 19C4.0147 19 2 16.9853 2 14.5c0-2.3436 1.7915-4.2687 4.0797-4.4806C6.5478 7.1721 9.0202 5 12 5s5.4522 2.1721 5.9203 5.0194C20.2085 10.2313 22 12.1564 22 14.5c0 2.4853-2.0147 4.5-4.5 4.5z"
    })
  }));
};
export default Cloud01;